import React from "react";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";

const MAX_DESCRIPTION = 160;

// Описание для поисковиков: одна строка без разметки, не длиннее ~160 символов
export const toDescription = (text) => {
  const plain = String(text || "")
    .replace(/[#*_>`[\]]/g, "")
    .replace(/\s+/g, " ")
    .trim();
  if (plain.length <= MAX_DESCRIPTION) return plain;
  const cut = plain.slice(0, MAX_DESCRIPTION - 1);
  return `${cut.slice(0, cut.lastIndexOf(" ") > 100 ? cut.lastIndexOf(" ") : cut.length)}…`;
};

// Заголовок, описание и превью для соцсетей/мессенджеров (Open Graph)
function MetaTag({ title, description, image, type = "website", noindex = false }) {
  // админку в поиск не пускаем
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) noindex = true;
  const { i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "ru";
  const url = typeof window !== "undefined" ? window.location.origin + window.location.pathname : "";
  const absImage = image ? new URL(image, window.location.origin).href : `${window.location.origin}/logo512.png`;
  const desc = toDescription(description);

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{title}</title>
      {desc && <meta name="description" content={desc} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <link rel="canonical" href={url} />}
      <meta property="og:site_name" content="RR Consulting & Property" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {desc && <meta property="og:description" content={desc} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absImage} />
      <meta property="og:locale" content={lang === "en" ? "en_US" : "ru_RU"} />
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
    </Helmet>
  );
}

export default MetaTag;
